import { useState } from 'react';

// @mui
import { MenuItem, Stack } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import useLocales from '../../locales/useLocales';

//Components

import MenuPopover from '../../components/menu-popover';
import IconButtonAnimate from '../../components/animate/IconButtonAnimate';

const LanguagePopover = () => {
  const { translate } = useLocales();
  const { allLangs, currentLang, onChangeLang } = useLocales();

  const [openPopover, setOpenPopover] = useState(null);

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleChangeLang = (newLang) => {
    onChangeLang(newLang);
    handleClosePopover();
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          width: 35,
          height: 35,
          ...(openPopover && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        <Avatar alt={currentLang.label} src={currentLang.icon} sx={{ width: 35, height: 35 }} />
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 180, mt: 2 }}>
        <Stack spacing={0.75}>
          {allLangs.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === currentLang.value}
              onClick={() => handleChangeLang(option.value)}
            >
              <Avatar
                alt={option.label}
                src={option.icon}
                sx={{ width: 34, height: 34, marginRight: 1 }}
              />

              {translate(option.label)}
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover>
    </>
  );
};

export default LanguagePopover;
